export default "__VITE_ASSET__c949d29a__"